export default myApp => {
  myApp
    .directive("onFinishRender", function($timeout) {
      return {
        restrict: "A",
        link: function(scope, element, attr) {
          if (scope.$last === true) {
            $timeout(function() {
              scope.$emit(attr.onFinishRender);
            });
          }
        }
      };
    })
    .directive("onFinishRenderTwo", function($timeout) {
      return {
        restrict: "A",
        link: function(scope, element, attr) {
          if (scope.$last === true) {
            $timeout(function() {
              scope.$emit(attr.onFinishRenderTwo);
            });
          }
        }
      };
    })
    .directive("starRating", function() {
      return {
        restrict: "EA",
        template:
          '<ul class="list booking-item-raiting-summary-list stats-list-select"><li><ul class="icon-group booking-item-rating-stars" style="font-size:100px;margin-left:9%;height:95px;" ng-class="{readonly: readonly}">' +
          '   <li ng-repeat="star in stars" class="" ng-class="{selected: star.filled}" style="display:inline-block;list-style-type:none;" ng-click="toggle($index)">' +
          '    <i class="fa fa-smile-o"></i>' + // or &#9733
          "  </li>" +
          " </li></ul></ul>",
        scope: {
          ratingValue: "=ngModel",
          max: "=?", // optional (default is 5)
          onRatingSelect: "&?",
          readonly: "=?"
        },
        link: function(scope, element, attributes) {
          if (scope.max == undefined) {
            scope.max = 5;
          }

          function updateStars() {
            scope.stars = [];

            for (var i = 0; i < scope.max; i++) {
              scope.stars.push({
                filled: i < scope.ratingValue
              });
            }
          }
          scope.toggle = function(index) {
            if (scope.readonly == undefined || scope.readonly === false) {
              scope.ratingValue = index + 1;
              scope.onRatingSelect({
                rating: index + 1
              });
            }
          };
          scope.$watch("ratingValue", function(oldValue, newValue) {
            if (newValue) {
              updateStars();
            }
          });
        }
      };
    })

    .directive("squareRating", function() {
      return {
        restrict: "EA",
        template:
          '<ul class="square-rating" ng-class="{readonly: readonly}">' +
          '  <li ng-repeat="star in stars" class="square" ng-class="{filled: star.filled}" ng-click="toggle($index)">' +
          '    <i class="fa fa-square" aria-hidden="true"></i>' + // or &#9733
          "  </li>" +
          "</ul>",
        scope: {
          ratingValue: "=ngModel",
          max: "=?", // optional (default is 5)
          onRatingSelect: "&?",
          readonly: "=?"
        },
        link: function(scope, element, attributes) {
          if (scope.max == undefined) {
            scope.max = 5;
          }

          function updateStars() {
            scope.stars = [];
            for (var i = 0; i < scope.max; i++) {
              scope.stars.push({
                filled: i < scope.ratingValue
              });
            }
          }
          scope.toggle = function(index) {
            if (scope.readonly == undefined || scope.readonly === false) {
              scope.ratingValue = index + 1;
              scope.onRatingSelect({
                rating: index + 1
              });
            }
          };
          scope.$watch("ratingValue", function(oldValue, newValue) {
            if (newValue) {
              updateStars();
            }
          });
        }
      };
    })

    .directive("progressbar", function() {
      return {
        restrict: "A",
        scope: {
          total: "=",
          current: "="
        },
        link: function(scope, element) {
          scope.$watch("current", function(value) {
            element.css("width", (scope.current / scope.total) * 100 + "%");
          });
          scope.$watch("total", function(value) {
            element.css("width", (scope.current / scope.total) * 100 + "%");
          });
        }
      };
    })
    .directive("autoSubmitFormccavenue", [
      "$timeout",
      "$sce",
      function($timeout, $sce) {
        return {
          replace: true,
          scope: {},
          template:
            '<form action="{{getUrl()}}" method="{{formData.method}}">' +
            ' <div ng-repeat="(key,val) in formData.params">' +
            '     <input type="hidden" name="{{ key }}" value="{{ val }}" />' +
            " </div>" +
            "</form>",
          link: function($scope, element, $attrs) {
            $scope.$on($attrs["event"], function(event, data) {
              $scope.formData = data;
              $scope.getUrl = function() {
                return $sce.trustAsResourceUrl($scope.formData.url);
              };
              $timeout(function() {
                element.submit();
              }, 100);
            });
          }
        };
      }
    ])
    .directive("dismissIosKeyboardOnClick", function() {
      return function(scope, element, attrs) {
        element.on("touchstart", function(e) {
          var keyboardDoms = new Set([
            "INPUT",
            "TEXTAREA",
            "SELECT",
            "input",
            "textarea",
            "select"
          ]);
          if (
            keyboardDoms.has(document.activeElement.nodeName) &&
            !keyboardDoms.has(e.target.nodeName)
          )
            document.activeElement.blur();
        });
      };
    });
};
